import React, { useEffect, useState } from 'react';
import './careerValue.css';
import { getCareerFAQ } from 'components/Service/CareerApi';
import TypedText from 'components/Homes/typewrite';

const uuid='40190ab5-fbd4-43f6-be0e-2e7a3e9b2b9e';


export default function CareerFaq() {
  // Set the first item open by default to exactly mirror image_0c8e41.png
  const [openId, setOpenId] = useState(0);
const [faqData, setFAQ] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getCareerFAQ(uuid);

        setFAQ(res);
      } catch (err) {
        console.error("Failed to fetch", err);
        setFAQ({});
      }
    };

    fetchData();
  }, []);
  const toggleAccordion = (id:any) => {
    setOpenId(openId === id ? null : id);
  };

    if (!faqData) return null;
  return (
    <section id='faq' className={`faq-section career-section d-flex align-items-center text-white ${faqData?.status ? '' : 'd-none'}`}>
      <div className="container pb-3">
        
        {/* Main Title Heading */}
        <h2 className="text-center fw-semibold mb-4 display-6 tracking-wide faq-title" data-wow-delay="0.1s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
          {faqData?.title || ""}
          {/* <TypedText
              index={1}
              text={`${faqData?.title || ''}`}
              delay={100}
              cursor="|"
            /> */}
        </h2>

        {/* Accordion Wrapper Container */}
        <div className="row justify-content-center">
          <div className="col-12 col-lg-12 col-xl-12">
            <div className="faq-list" data-wow-delay="0.5s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
              
              {faqData?.items?.map((item:any,index:number) => {
                const isOpen = openId === index;
                
                return (
                  <div key={item.id} className="faq-item">
                    
                    {/* Header Button Panel */}
                    <button 
                      className="faq-trigger w-100 d-flex align-items-center justify-content-between text-start border-0 bg-transparent text-white py-4 px-0 shadow-none"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={isOpen}
                    >
                      <span className="faq-question fw-semibold pe-3">
                        {item.question}
                      </span>
                      
                      {/* Plus / Minus Indicator Icon */}
                      <span className={`faq-icon-wrapper flex-shrink-0 d-flex align-items-center justify-content-center ${isOpen ? 'is-active' : ''}`}>
                        {isOpen ? (
                          <i className="bi bi-dash l-icon"></i>
                        ) : (
                          <i className="bi bi-plus l-icon"></i>
                        )}
                      </span>
                    </button>

                    {/* Expandable Body Panel */}
                    <div className={`faq-body-collapse ${isOpen ? 'show-panel' : ''}`}>
                      <div className="faq-content pb-4 text-white-100">
                        <p className="mb-0 lh-lg"  dangerouslySetInnerHTML={{
                              __html: item.answer,
                            }} />
                        
                      </div>
                    </div>

                  </div>
                );
              })}

            </div>
          </div>
        </div>

      </div>
    </section>
  );
}